import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";

import type { DriverRow } from "@/types/driver";
import ContextTile from "./ContextTile";
import { changedAt, NO_VALUE } from "./contextFormat";

/** Whether hands-free is on, and when the device last reported it. */
export default function HandsFreeTile({ driver }: { driver: DriverRow }) {
  const enabled = driver.mostRecentHandsFreeStatusEnabled;
  const value = enabled == null ? NO_VALUE : enabled ? "On" : "Off";
  return (
    <ContextTile
      icon={<HeadsetMicOutlinedIcon sx={{ fontSize: 18 }} />}
      label="Hands-free"
      value={value}
      footnote={changedAt(driver.mostRecentHandsFreeStatusUpdatedAt, "updated")}
    />
  );
}
